var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6C20 6.55333 19.5533 7 19 7H5C4.44667 7 4 6.55333 4 6C4 5.44667 4.44667 5 5 5H19C19.5533 5 20 5.44667 20 6ZM13.6667 17H10.3333C9.78 17 9.33333 17.4467 9.33333 18C9.33333 18.5533 9.78 19 10.3333 19H13.6667C14.22 19 14.6667 18.5533 14.6667 18C14.6667 17.4467 14.22 17 13.6667 17ZM16.3333 11H7.66667C7.11333 11 6.66667 11.4467 6.66667 12C6.66667 12.5533 7.11333 13 7.66667 13H16.3333C16.8867 13 17.3333 12.5533 17.3333 12C17.3333 11.4467 16.8867 11 16.3333 11Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsFilter);
export default __webpack_public_path__ + "static/media/bars-filter.34d1107945c0b1ef61c9f521da22c178.svg";
export { ForwardRef as ReactComponent };